import React, { useState } from "react";
import EditIcon from "../../Common/svg/productshow/edit";
import PlusIcon from "../../Common/svg/productshow/plus";
import DeleteIcon from "../../Common/svg/productshow/delete";
import OfferModal from "./offerModal";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { deleteProduct } from "../../../MyApi/product";
import { toast } from "react-toastify";

const ActionsCard = ({ id ,refetch }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDeletMutation =useMutation({mutationKey:["deleteMutation"],mutationFn:()=>deleteProduct(id),onSuccess:(data)=>{
    toast.success(`${data.message}`)
    navigate(`${process.env.PUBLIC_URL}/products`)  
  }})
  return (   
    <>
      {" "}
      <div className="card rounded-3">
        <div className="card-body">
          <h4 className="font16 font700"> الإجراءات السريعة</h4>
          <div className="bg-neutral-100 mt-4 mb-2 p-2 rounded-3 d-flex gap-2 align-items-center btn"  onClick={()=>navigate(`${process.env.PUBLIC_URL}/product/edit/${id}`)}>
           
              <EditIcon />
           
            <h5 className="font14 desc">تعديل</h5>
          </div>
          <div className="bg-neutral-100 mt-4 mb-2 p-2 rounded-3 d-flex gap-2 align-items-center btn"    onClick={openModal}>
         
              <PlusIcon />
        
            <h5 className="font14 text-green">إضافة عرض خاص</h5>
          </div>
          <div className="bg-neutral-100 mt-4 mb-2 p-2 rounded-3 d-flex gap-2 align-items-center btn" onClick={()=>handleDeletMutation.mutate()}>
     
              <DeleteIcon />
        
            <h5 className="font14 text-danger">حذف المنتج</h5>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <OfferModal
          isModalOpen={isModalOpen}
          offerableId={id}
          closeModal={closeModal}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default ActionsCard;
